<template>
  <v-inventory-view
    name="purchase"
    title="purchase_orders"
    large
    to="/inventory/purchase"
    receive="/inventory/receive"
    v-bind:headers="headers"
    cancel
    inv-purchase
    no-total
  >
    <template #header="{data}">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{data.p_order}}</v-list-item-title>
          <v-list-item-subtitle>{{$t(data.status)}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action style="width: 150px">
          <v-progress-linear
            :color="data.status=='partially'?'rgb(140,199,72)':'rgba(0,0,0,0.26)'"
            background-color="white"
            height="10"
            style="border: 1px solid rgba(0,0,0,0.26); margin-top: 10px"
            v-bind:value="data.received / data.total_count * 100"
            striped
          />
          <v-list-item-action-text>{{$t('received')}} {{data.received}} of {{data.total_count}}</v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          <span class="subtitle-2">{{$t('date')}}:</span>
          <span class="body-2">{{(new Date(data.purchase_order_date)).toDateString()}}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          <span class="subtitle-2">{{$t('ordered_by')}}:</span>
          <span class="body-2">{{data.ordered_by_name}}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('supplier')}}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{data.supplier_name}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('destination_store')}}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{data.service_name}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-inventory-view>
</template>
<script>
export default {
  name: "InventoryPurchaseView",
  data: () => ({
    // headers: [
    //   { text: "Item", value: "name" },
    //   { text: "Quantity", value: "quality" },
    //   { text: "Purchase cost", value: "purchase_cost" },
    //   { text: "Amount", value: "amount" },
    // ],
  }),
  computed: {
    headers() {
      let headers = [];
      headers = [
        { text: this.$t("item"), value: "name" },
        { text: this.$t("quantity"), value: "quality", align: "right" },
      ]
      if(this.user_access && this.user_access.inv_purchase_orders_cost) {
        headers.push({
          text: this.$t("purchase_cost"),
          value: "purchase_cost",
          align: "right",
        })
        headers.push({ text: this.$t("amount"), value: "amount", align: "right" })
      }
      return headers
    }
  },
  mounted() {
    // this.headers = [
    //   { text: this.$t("item"), value: "name" },
    //   { text: this.$t("quantity"), value: "quality", align: "right" },
    //   {
    //     text: this.$t("purchase_cost"),
    //     value: "purchase_cost",
    //     align: "right",
    //   },
    //   { text: this.$t("amount"), value: "amount", align: "right" },
    // ];
  },
};
</script>
